(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aaronya-deserve-colorways"] && !Shopify.designMode) return;
  try {
    class AaronyaProductColorways extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      const trigger = this.querySelector('[data-aaronya-colorways-toggle]');
      const overflow = this.querySelector('[data-aaronya-colorways-overflow]');
      const moreLabel = this.querySelector('[data-aaronya-more-label]');
      const lessLabel = this.querySelector('[data-aaronya-less-label]');

      if (!trigger || !overflow) return;

      trigger.addEventListener('click', () => {
        const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
        trigger.setAttribute('aria-expanded', String(willOpen));
        overflow.setAttribute('aria-hidden', String(!willOpen));
        overflow.classList.toggle('is-open', willOpen);

        if (moreLabel) moreLabel.hidden = willOpen;
        if (lessLabel) lessLabel.hidden = !willOpen;
      });
    }
  }

  if (!customElements.get('aaronya-product-colorways')) {
    customElements.define('aaronya-product-colorways', AaronyaProductColorways);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aaronya-room-offer"] && !Shopify.designMode) return;
  try {
    class AaronyaRoomOffer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.dialog = this.querySelector('[data-room-offer-dialog]');
      this.steps = Array.from(this.querySelectorAll('[data-room-offer-step]'));
      this.email = this.querySelector('[data-room-offer-email]');
      this.tags = this.querySelector('[data-room-offer-tags]');
      this.selection = this.querySelector('[data-room-offer-selection]');
      this.dismissKey = 'aaronya-room-offer-dismissed-at';
      this.successKey = 'aaronya-room-offer-subscribed-at';
      this.sessionKey = 'aaronya-room-offer-shown';
      this.triggered = false;

      if (!this.dialog) return;

      this.querySelectorAll('[data-room-choice]').forEach((button) => {
        button.addEventListener('click', () => this.chooseRoom(button.dataset.roomChoice));
      });

      this.querySelector('[data-room-offer-back]')?.addEventListener('click', () => {
        this.showStep('room');
      });

      this.querySelectorAll('[data-room-offer-close]').forEach((button) => {
        button.addEventListener('click', () => this.rememberDismissal());
      });

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.closeOffer();
      });

      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = '';
      });

      this.querySelector('[data-room-offer-copy]')?.addEventListener('click', (event) => {
        this.copyCode(event.currentTarget);
      });

      if (this.querySelector('[data-room-offer-posted]')) {
        this.writeStorage(this.successKey, Date.now());
        this.showStep('success');
        this.open();
        return;
      }

      if (this.querySelector('[data-room-offer-errors]')) {
        this.showStep('email');
        this.open();
        return;
      }

      if (!this.isEligible()) return;

      const delay = Number(this.dataset.delay) || 7000;
      this.openTimer = window.setTimeout(() => this.open(), delay);
      this.scrollHandler = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable > 0 && window.scrollY / scrollable >= 0.3) {
          this.open();
        }
      };
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
    }

    disconnectedCallback() {
      window.clearTimeout(this.openTimer);
      window.removeEventListener('scroll', this.scrollHandler);
    }

    isEligible() {
      const previewParams = new URLSearchParams(window.location.search);
      if (previewParams.get('aaronya_offer_preview') === '1') return true;
      if (this.dataset.themeRole && this.dataset.themeRole !== 'main') return true;

      if (this.readStorage(this.sessionKey)) return false;

      const now = Date.now();
      const dismissDays = Number(this.dataset.dismissDays) || 7;
      const successDays = Number(this.dataset.successDays) || 30;
      const dismissedAt = Number(this.readStorage(this.dismissKey)) || 0;
      const subscribedAt = Number(this.readStorage(this.successKey)) || 0;

      if (dismissedAt && now - dismissedAt < dismissDays * 86400000) return false;
      if (subscribedAt && now - subscribedAt < successDays * 86400000) return false;
      return true;
    }

    chooseRoom(room) {
      if (this.tags) this.tags.value = 'newsletter, Aaronya room offer, Room: ' + room;
      if (this.selection) this.selection.textContent = room;
      this.showStep('email');
      window.setTimeout(() => this.email?.focus(), 80);
    }

    showStep(name) {
      this.steps.forEach((step) => {
        step.hidden = step.dataset.roomOfferStep !== name;
      });
    }

    open() {
      if (this.triggered || this.dialog.open) return;

      this.triggered = true;
      window.clearTimeout(this.openTimer);
      window.removeEventListener('scroll', this.scrollHandler);
      this.writeStorage(this.sessionKey, 'true');
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.querySelector('[data-room-choice]')?.focus();
    }

    closeOffer() {
      if (!this.dialog.open) return;

      this.rememberDismissal();
      this.dialog.close();
      this.dialog.removeAttribute('open');
      document.documentElement.style.overflow = '';
    }

    rememberDismissal() {
      const completed = !this.querySelector('[data-room-offer-step="success"]')?.hidden;
      this.writeStorage(completed ? this.successKey : this.dismissKey, Date.now());
    }

    async copyCode(button) {
      try {
        await navigator.clipboard.writeText('CANVAS15');
        const label = button.querySelector('[data-room-offer-copy-label]');
        const status = this.querySelector('[data-room-offer-copy-status]');
        if (label) label.textContent = button.dataset.copiedLabel;
        if (status) status.textContent = button.dataset.copiedLabel;
      } catch (error) {
        const status = this.querySelector('[data-room-offer-copy-status]');
        if (status) status.textContent = 'CANVAS15';
      }
    }

    readStorage(key) {
      try {
        return window.localStorage.getItem(key) || window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    writeStorage(key, value) {
      try {
        if (key === this.sessionKey) {
          window.sessionStorage.setItem(key, String(value));
          return;
        }
        window.localStorage.setItem(key, String(value));
      } catch (error) {
        return;
      }
    }
  }

  if (!customElements.get('aaronya-room-offer')) {
    customElements.define('aaronya-room-offer', AaronyaRoomOffer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    class AaronyaPricePresets extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.updatePressedState();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = (event) => {
      const button = event.target.closest('[data-min][data-max]');
      if (!(button instanceof HTMLButtonElement)) return;
      const facet = this.closest('price-facet-component');
      if (!facet) return;
      const minInput = facet.querySelector('[ref="minInput"]');
      const maxInput = facet.querySelector('[ref="maxInput"]');
      if (!(minInput instanceof HTMLInputElement) || !(maxInput instanceof HTMLInputElement)) return;
      minInput.value = button.dataset.min || '';
      maxInput.value = button.dataset.max || '';
      this.updatePressedState();
      facet.updatePriceFilterAndResults();
    };

    updatePressedState() {
      const facet = this.closest('price-facet-component');
      const minInput = facet?.querySelector('[ref="minInput"]');
      const maxInput = facet?.querySelector('[ref="maxInput"]');
      if (!(minInput instanceof HTMLInputElement) || !(maxInput instanceof HTMLInputElement)) return;
      this.querySelectorAll('[data-min][data-max]').forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) return;
        button.setAttribute(
          'aria-pressed',
          String((button.dataset.min || '') === minInput.value && (button.dataset.max || '') === maxInput.value)
        );
      });
    }
  }

  if (!customElements.get('aaronya-price-presets')) {
    customElements.define('aaronya-price-presets', AaronyaPricePresets);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-size-guide-open]');
    const closeButton = event.target.closest('[data-size-guide-close]');

    if (openButton) {
      document.getElementById(openButton.getAttribute('aria-controls'))?.showModal();
    }

    if (closeButton) {
      closeButton.closest('dialog')?.close();
    }

    if (event.target instanceof HTMLDialogElement && event.target.matches('.variant-picker__size-guide-dialog')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
